module.exports = require('./helpers/bundle-url').getBundleURL('b8rBz') + "logo.c51670a8.svg";